import { inject, Injectable, PLATFORM_ID, TransferState } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { Campaign } from './model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampaignServiceService {

  platformId = inject(PLATFORM_ID);
  transferState = inject(TransferState);

  constructor(private http: HttpClient) { }

  getAll(): Observable<Campaign[]> {
    return this.http.get<Campaign[]>(
      `${environment.apiUrl}/Campaign/GetAllCampaigns`);
  }

  get(id: number): Observable<Campaign> {
    return this.http.get<Campaign>(
      `${environment.apiUrl}/Campaign/GetCampaign/${id}`);
  }

  save(data: Campaign): Observable<Campaign> {
    return this.http.post<Campaign>(`${environment.apiUrl}/Campaign/SaveCampaign/`, data)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return throwError(() => new Error(err?.error?.error ?? err.statusText));
        })
      );
  }

  activate(id: number): Observable<Campaign> {
    return this.http.get<Campaign>(
      `${environment.apiUrl}/Campaign/ActivateCampaing/${id}`)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return throwError(() => new Error(err?.error?.error ?? err.statusText));
        })
      );
  }

  deactivate(id: number): Observable<Campaign> {
    return this.http.get<Campaign>(
      `${environment.apiUrl}/Campaign/DeactivateCampaing/${id}`)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return throwError(() => new Error(err?.error?.error ?? err.statusText));
        })
      );
  }

  clean(id: number): Observable<Campaign> {
    return this.http.get<Campaign>(
      `${environment.apiUrl}/Campaign/CleanCampaing/${id}`)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return throwError(() => new Error(err?.error?.error ?? err.statusText));
        })
      );
  }
}
